/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ClassIcon from '@material-ui/icons/Class';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import ListIcon from '@material-ui/icons/List';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import PagesIcon from '@material-ui/icons/Pages';
import PeopleIcon from '@material-ui/icons/People';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutlined';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import PermMediaIcon from '@material-ui/icons/PermMedia';
import PhoneIcon from '@material-ui/icons/PhoneAndroidOutlined';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import SchoolIcon from '@material-ui/icons/School';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import SportsKabaddiIcon from '@material-ui/icons/SportsKabaddi';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import { account_manager, curriculum_manager, ecommerce_manager, finance_manager } from 'utils/constants';
import HelpIcon from '@material-ui/icons/Help';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';

export default [{
  title: 'Pages',
  pages: [{
    title: 'Lesson Overview',
    href: '/overview',
    icon: HomeIcon,
  }, {
    title: 'Weekly Overview',
    href: '/weekly-overview',
    icon: ListIcon,
  }, {
    title: 'Account Management',
    icon: PeopleOutlineIcon,
    roles: [account_manager],
    children: [{
      title: "Accounts",
      href: '/accounts',
      icon: PeopleOutlineIcon
    }, {
      title: "Students",
      href: '/students',
      icon: SchoolIcon
    }, {
      title: "Teachers",
      href: '/teachers',
      icon: PeopleIcon
    }]
  }, {
    title: 'Curriculum',
    icon: PagesIcon,
    roles: [curriculum_manager],
    children: [{
      title: 'Masteries',
      href: '/masteries',
      icon: TrendingUpIcon,
    }, {
      title: 'Modules',
      href: '/modules',
      icon: BubbleChartIcon
    }, {
      title: 'Routines',
      href: '/routines',
      icon: SportsKabaddiIcon
    }]
  }, {
    title: 'Schedule',
    icon: CalendarTodayIcon,
    roles: [curriculum_manager],
    children: [{
      title: 'Lessons',
      href: '/lessons',
      icon: ClassIcon,
    }, {
      title: 'Bookings',
      href: '/bookings',
      icon: PermContactCalendarIcon,
    }]
  }, {
    title: 'Commerce',
    icon: AttachMoneyIcon,
    children: [{
      title: 'Transactions',
      href: '/transactions',
      icon: CompareArrowsIcon,
      roles: [finance_manager]
    }, {
      title: 'Orders',
      href: '/orders',
      icon: ShoppingCartIcon,
      roles: [finance_manager]
    }, {
      title: 'Class Passes',
      href: '/class-passes',
      icon: ConfirmationNumberIcon,
      roles: [ecommerce_manager]
    }, {
      title: 'Topup Options',
      href: '/topup-options',
      icon: MonetizationOnIcon,
      roles: [ecommerce_manager]
    }, {
      title: 'Item Classes',
      href: '/item-classes',
      icon: CardTravelIcon,
      roles: [ecommerce_manager]
    }]
  },
  {
    title: 'Activities',
    href: '/activities',
    icon: PermMediaIcon
  },
  {
    title: 'Notices',
    href: '/notices',
    icon: RecordVoiceOverIcon
  },
  {
    title: 'Mobile App',
    href: '/app/download',
    icon: PhoneIcon,
  },
  {
    title: 'Help',
    href: '/help',
    icon: HelpIcon,
  },
  ]
}];
